import React, { Fragment } from "react"
import { TxtFile, BodyTxt } from "./styles"

const ShowTxtFile = ({ fileContents }) => {
    let lines = fileContents.split("\n")
    const toDisplay = lines.map((line, index) => {
        return (
            <Fragment key={index}>
                <BodyTxt>{line}</BodyTxt>
                <br />
            </Fragment>
        )
    })

    return (
        <div className="TextFile">
            <TxtFile>{toDisplay}</TxtFile>
        </div>
    )
}

export default ShowTxtFile



// WEBPACK FOOTER //
// ./src/OctoprintParser/ShowTxtFile/index.js